import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader-wrapper", {active: _ctx.visible}])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "d-flex justify-content-center loader-container",
          style: _normalizeStyle([{"z-index":"1000"}, {'background-color': _ctx.backgroundColorValue}])
        }, [
          _createElementVNode("div", {
            class: "spinner-border",
            role: "status",
            style: _normalizeStyle({'zoom': _ctx.zoomValue})
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "visually-hidden" }, null, -1)
          ]), 4)
        ], 4))
      : _createCommentVNode("", true)
  ], 2))
}